import {di} from "@dp-instant/core";
import {Localize} from "@dp-instant/i18n";
import {TypesFlow, TypesSocial} from "@dp-instant/interfaces";
import {LevelStartAction} from "@dp-instant/gameflow";
import {IReferralRewardsModel} from "@dp-instant/social";
import {Button, Icon} from "@dp-instant/ui";
import {ILeaderobardInviteItemProps, Reward} from "@game/ui/interface/ILeaderBoardProps";
import cn from "classnames";
import {useState} from "preact/hooks";
import {SVG} from "../images";
import "./LeaderBoard.less";

const getReward = (reward: Reward) => (
    <div className={cn("button-invite__reward-icon")}>
        <SVG.COINS />
    </div>
);

export const LeaderBoardInviteItem = ({
    className,
    pending,
    reward
}: ILeaderobardInviteItemProps) => {
    const initialState = {
        isPending: pending
    };

    const [state, setState] = useState(() => initialState);

    const onInvite = async () => {
        const refModel: IReferralRewardsModel<Reward> = di.get(TypesSocial.refRewardsModel);
        if (await refModel.request(reward)) {
            setState(state => ({...state, isPending: true}));
            const levelStartAction = di.get<LevelStartAction>(TypesFlow.LevelStart); // instantiate new because waitForContext
            levelStartAction.waitForContextChange = true;
            await levelStartAction.run();
        }
    };

    return (
        <li
            className={cn(
                "leaderboard__item",
                "leaderboard__item-invite",
                {"leaderboard__item-invite_disabled": state.isPending},
                className
            )}
        >
            <Button disabled={state.isPending} onClick={onInvite} className={cn("btn-green")}>
                <div className={cn("button-invite")}>
                    <div className={cn("button-invite__icon")}>
                        <Icon type={"friends"} />
                    </div>
                    <div className={cn("button-invite__text")}>
                        {state.isPending
                            ? Localize.get("game_pending", "Pending...")
                            : Localize.get("game_invite", "Invite Friend")}
                        {state.isPending ? (
                            <span className={cn("button-invite__description")}>
                                {Localize.get(
                                    "game_pending_description",
                                    "The reward is given when your friend launch the game."
                                )}
                            </span>
                        ) : null}
                    </div>
                    <div className={cn("button-invite__reward")}>
                        {getReward(reward)}
                        <div className={cn("button-invite__reward-count")}>
                            {"+"}
                            {reward.count}
                        </div>
                    </div>
                </div>
            </Button>
        </li>
    );
};
